import { useEffectOnce } from 'react-use';

import { isSSR } from 'helpers/environment';
import { allProducts } from 'helpers/fakeData';
import { safeLocalStorage } from 'helpers/localStorage';
import { CartItem } from 'stores/marketPlaceStore';
import { useStores } from 'stores/rootStore';

const isValidCartItem = (item: CartItem) => {
  return (
    'id' in item && 'quantity' in item && allProducts.some((product) => product.id === item.id)
  );
};

const getCartFromLocalStorage = (cartId: string) => {
  const cart = safeLocalStorage.getItem(cartId);
  if (cart == null) {
    return null;
  }
  const cartItems = JSON.parse(cart) as CartItem[];
  return cartItems.filter((item) => isValidCartItem(item));
};

export const useGetCart = (cartId: string) => {
  const { marketPlaceStore } = useStores();
  const isServer = isSSR();
  const cart = getCartFromLocalStorage(cartId) ?? marketPlaceStore.cart;

  return {
    cart,
    loading: isServer,
  };
};

export const useInitCart = () => {
  const { marketPlaceStore } = useStores();

  useEffectOnce(() => {
    const cartId = safeLocalStorage.getItem('cartId');
    if (cartId == null) {
      return;
    }
    marketPlaceStore.setCartId(cartId);
    const cart = getCartFromLocalStorage(cartId);
    if (cart == null) {
      return;
    }
    for (const item of cart) {
      marketPlaceStore.addToCart(item);
    }
  });
};
